import { logEvent, setUserProperties } from "firebase/analytics";
import { analytics } from "./firebase";

const isOnline = typeof navigator !== 'undefined' ? navigator.onLine : true;

export function logEventAnalytics(event, object) {
    if (!analytics || !isOnline) {
        return;
    }
    try {
        logEvent(analytics, event, object);
    } catch (error) {
        console.error('Erro ao enviar analytics', error);
    }
}

export function setUserPropertiesAnalytics(object) {
    if (!analytics || !isOnline) {
        return;
    }
    try {
        setUserProperties(analytics, object);
    } catch (error) {
        console.error('Erro ao definir propriedades do usuário', error);
    }
}